import {
  MdDashboard,
  MdPeople,
  MdEvent,
  MdFeedback,
  MdInventory,
  MdGroup,
  MdMeetingRoom,
  MdPerson,
  MdShield,
  MdLocalHospital,
} from "react-icons/md";

export const permissionMap = {
  'Dashboard':          'Dashboard View',
  'Patients':           'Patients View',
  'OT Rooms':           'OT Rooms View',
  'OT Booking':         'OT Booking View',
  'Patient Feedback':   'Patient Feedback View',
  'Inventory':          'Inventory View',
  'User List':        'Users View',
  'Role List':         'Roles View',
  'Role Management':    'Roles View',
};

export const navGroups = [
  {
    label: 'Main',
    items: [{ name: 'Dashboard', icon: MdDashboard }]
  },
  {
    label: 'Clinical',
    items: [
      { name: 'Patients', icon: MdPeople },
      {
        name: 'Operations',
        icon: MdLocalHospital,
        subItems: [
          { name: 'OT Rooms', icon: MdMeetingRoom },
          { name: 'OT Booking', icon: MdEvent }
        ]
      },
      { name: 'Patient Feedback', icon: MdFeedback }
    ]
  },
  {
    label: 'Administration',
    items: [
      { name: 'Inventory', icon: MdInventory },
      {
        name: 'User Management',
        icon: MdGroup,
        subItems: [
          { name: 'User List', icon: MdPerson },
          { name: 'Role List',       icon: MdShield },
          { name: 'Role Management', icon: MdShield },
        ]
      }
    ]
  }
];
